import { Clock, LogOut, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';
import { Button } from '@/components/ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_imageblaze/artifacts/5e5w021j_7D777DBC-744F-44B3-9C70-7AE1E6146D31.png";

const PendingApproval = ({ user }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (error) {
      console.error('Logout error:', error);
    }
    // Clear all auth data (localStorage, sessionStorage, cookies)
    localStorage.removeItem('session_token');
    sessionStorage.clear();
    document.cookie = 'session_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {/* Logo DLV Express */}
          <div className="mb-6">
            <img src={LOGO_URL} alt="DLV EXPRESS" className="h-20 w-auto mx-auto" />
          </div>

          {/* Icon */}
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-8 h-8 text-yellow-600" />
          </div>

          <h1 className="text-2xl font-bold text-[#0F172A] font-['Chivo'] mb-2">
            Statut du compte
          </h1>
          
          <p className="text-gray-700 mb-4">
            Bonjour <span className="font-bold">{user?.name}</span>,
          </p>
          
          <p className="text-gray-600 mb-6 leading-relaxed">
            Votre demande d'inscription a bien été reçue.<br/>
            Votre compte est actuellement en attente d'approbation ou temporairement désactivé.
          </p>

          <div className="p-4 bg-blue-50 rounded-xl mb-6 border border-blue-200">
            <p className="text-sm text-gray-700 leading-relaxed">
              L'administration procède aux vérifications nécessaires. Vous serez informé dès que votre statut aura été mis à jour.
            </p>
          </div>

          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Se déconnecter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
